export default __webpack_public_path__ + "images/Head_Circumference_blue.ca6c8b13400c605d982ade2aeb22b3f4.png";